<script setup lang="ts">
import store from "@/store";

import { mobileHeader, footerMenu, fullLoading } from "@/common/components";

defineProps<{
  menuList: any[];
}>();

const headerHeight = "4rem";
const footerHeight = "4.5rem";
</script>

<template>
  <section class="screen">
    <section class="pages">
      <mobile-header :height="headerHeight" />
      <main class="main">
        <slot name="main"></slot>
      </main>
      <footer-menu :menu-list="menuList" :height="footerHeight" />
    </section>

    <template v-if="store.getters.loading">
      <full-loading />
    </template>
  </section>
</template>

<style lang="scss" scoped>
$header-height: v-bind("headerHeight");
$footer-height: v-bind("footerHeight");

.screen {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100dvh;

  .pages {
    display: flex;
    flex-direction: column;

    main {
      display: flex;
      flex-direction: column;
      padding-block: 1rem;
      padding-inline: 1rem;
      height: calc(100dvh - $header-height - $footer-height - 2rem);
      overflow-y: auto;
    }
  }
}
</style>
